<template>
  <div
    class="server-busy-error"
    style="background-color: #f6f8fb;">
    <el-card class="error_container">

      <div
        class="mx-24 my-24 el-text el-text--display-medium"
        style="text-align: center;">
        {{ $t('error.server-busy.message') }}
      </div>

    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ServerBusyError'
};
</script>

<style lang="scss" scoped>
.server-busy-error {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.error_container {
  width: 512px;
}
</style>
